import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
} from "@angular/core";
import { PublicationModel } from "../../../interfaces/publication-model";
import {
    MatCard,
    MatCardContent,
    MatCardFooter,
    MatCardHeader,
    MatCardTitle,
} from "@angular/material/card";
import { MatChip, MatChipSet } from "@angular/material/chips";
import { Router } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { PublicationService } from "../../../services/publication.service";
import { filter, switchMap, take } from "rxjs";
import { ClonePublicationDialogComponent } from "../../layout/dialogs/clone-publication-dialog/clone-publication-dialog.component";

@Component({
    standalone: true,
    selector: "gwo-publication-tile",
    imports: [
        MatCard,
        MatCardTitle,
        MatCardHeader,
        MatCardContent,
        MatCardFooter,
        MatChipSet,
        MatChip,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
    ],
    templateUrl: "./publication-tile.component.html",
    styleUrl: "./publication-tile.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicationTileComponent {
    @Input() publication?: PublicationModel;
    @Input() existingNames: string[] = [];

    private readonly dialog = inject(MatDialog);
    private readonly publicationService = inject(PublicationService);

    constructor(private readonly router: Router) {}

    onPublicationOpen(): void {
        this.router.navigate(["publication", this.publication?.id]);
    }

    onClone(): void {
        if (!this.publication?.id) return;
        this.publicationService
            .getSinglePublication(String(this.publication.id))
            .pipe(
                take(1),
                switchMap((fullPublication) =>
                    this.dialog
                        .open(ClonePublicationDialogComponent, {
                            width: "480px",
                            data: {
                                publication: fullPublication,
                                existingNames: this.existingNames,
                            },
                        })
                        .afterClosed(),
                ),
                filter(Boolean),
            )
            .subscribe((savedPublication) => {
                this.router.navigate(["publication", savedPublication.id]);
            });
    }
}
